export var APLUS_LOGKEY = "/cnux.1.0";
export var APLUS_HOST = "gm.mmstat.com";
export var APLUS_URL = "https://".concat(APLUS_HOST).concat(APLUS_LOGKEY);
export var COOKIE_UID_KEY = "arms_uid";
export var COOKIE_UID_MAXAGE = 180 * 24 * 3600;
export var PREF_APLUS_LOGKEY = "/cnux.1.0";
export var PREF_APLUS_URL = "".concat(APLUS_HOST).concat(PREF_APLUS_LOGKEY);
export var VALUE_LIMIT = 512;
export var US_TIMEZONES = [
    "Pacific/Midway",
    "Pacific/Wake",
    "America/Adak",
    "America/Anchorage",
    "America/Boise",
    "America/Chicago",
    "America/Denver",
    "America/Denver",
    "America/Detroit",
    "America/Indiana/Indianapolis",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Indianapolis",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Los_Angeles",
    "America/Louisville",
    "America/Menominee",
    "America/Metlakatla",
    "America/Ne",
    "America/New_York",
    "America/Nome",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Phoenix",
    "America/Sitka",
    "America/Thunder_Bay",
    "America/Yakutat",
    "Pacific/Honolulu"
];

 //# sourceMappingURL=constant.js.map